import React, { useRef, useState } from 'react'

import { Box, TextField } from '@mui/material'
import type { ShowFilter } from 'features/customers/constants/contactsActivity'

import ContactsAtAGlance from './ContactsAtAGlance'
import ContactsRequests from './ContactsRequests'
import ContactsUnlocks, { type ReservationFilter, type ReservationLink } from './ContactsUnlocks'

const currentPeriod = () => new Date().toISOString().slice(0, 7)

const scrollTo = (section: React.RefObject<HTMLDivElement | null>) =>
  section.current?.scrollIntoView?.({ behavior: 'smooth', block: 'start' })

const CustomerContactsActivity = () => {
  const [period, setPeriod] = useState(currentPeriod)
  const [show, setShow] = useState<ShowFilter>('all')
  const [reservationOfPerson, setReservationOfPerson] = useState<ReservationLink | null>(null)
  const [peopleOfReservation, setPeopleOfReservation] = useState<ReservationFilter | null>(null)
  const requests = useRef<HTMLDivElement>(null)
  const people = useRef<HTMLDivElement>(null)

  const showRequest = (reservationId: number) => {
    setReservationOfPerson({ reservationId })
    setShow('all')
    scrollTo(requests)
  }

  const showRequests = (filter: ShowFilter) => {
    setShow(filter)
    scrollTo(requests)
  }

  return (
    <Box data-testid="contacts-activity" sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <TextField
        label="Month (UTC)"
        onChange={e => {
          if (!e.target.value) return
          setPeriod(e.target.value)
          setReservationOfPerson(null)
          setPeopleOfReservation(null)
        }}
        size="small"
        sx={{ width: 200 }}
        type="month"
        value={period}
        slotProps={{ inputLabel: { shrink: true } }}
      />
      <ContactsAtAGlance onShow={showRequests} period={period} show={show} />
      <Box ref={requests}>
        <ContactsRequests
          onClearReservation={() => setReservationOfPerson(null)}
          onShow={setShow}
          onShowRequest={showRequest}
          onShowPeople={({ id, meter }) => {
            setPeopleOfReservation({ reservationId: id, meter })
            scrollTo(people)
          }}
          period={period}
          reservation={reservationOfPerson}
          show={show}
        />
      </Box>
      <Box ref={people}>
        <ContactsUnlocks
          onClearReservation={() => setPeopleOfReservation(null)}
          onShowRequest={showRequest}
          period={period}
          reservation={peopleOfReservation}
        />
      </Box>
    </Box>
  )
}

export default CustomerContactsActivity
